class Cookies {
  cookieName = 'confirmCookie';
  cookieExpiryDays = 7;
  showClass = 'show';
  hideClass = 'hide';

  cookiesContainer;
  confirmButton;

  init() {
    this.cookiesContainer = document.querySelector('.cookies');
    if (!this.cookiesContainer) return;

    this.confirmButton =
      this.cookiesContainer.querySelector('.cookies__confirm');

    if (this.getCookie(this.cookieName)) {
      this.cookiesContainer.remove();
      return;
    }

    this.showCookies();

    this.confirmButton.addEventListener('click', () => {
      this.confirmCookie();
    });
  }

  getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) return value;
    }
    return null;
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setDate(date.getDate() + days);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  showCookies() {
    setTimeout(() => {
      this.cookiesContainer.classList.add(this.showClass);
    }, 1000);
  }

  hideCookies() {
    this.cookiesContainer.classList.remove(this.showClass);
    this.cookiesContainer.classList.add(this.hideClass);

    setTimeout(() => {
      this.cookiesContainer.remove();
    }, 300);
  }

  confirmCookie() {
    this.hideCookies();
    this.setCookie(this.cookieName, 'true', this.cookieExpiryDays);
  }
}

export const cookies = new Cookies();
